
function Footer() {

  return (
    <footer className="text-center bg-darkgrey p-2 pt-3 mt-5">
        <p>&copy; <a href="https://www.iac.es" target="_blank">Instituto de Astrofísica de Canarias</a> - Made with <i class="bi bi-heart-fill text-danger"></i> by the IAC's <a href="https://research.iac.es/sieinvens" target="_blank" title="IAC's Specialized Informatics Services for Astronomy">SIE de Investigación</a>.</p>
    </footer>
  );
}

export default Footer;